
import { Name } from "./name";
import { OptionMenu } from "./option-menu";

class GenderOptionMenu extends OptionMenu {
  constructor(name) {
    super(name, [
      new Name("male", "Male"),
      new Name("female", "Female"),
    ]);
  }
}

export { GenderOptionMenu };
